module.exports = __webpack_public_path__ + "img/LAND6.ea029b94.jpg";